import React from 'react';
import { COUNTRIES } from '../../config/countries';
import type { CountryCode } from '../../config/countries';

interface ChosenCountryProps {
  country: CountryCode;
  onChange(): void;
  className?: string;
}

/** The country a product page is open on, with the way back to the chooser. */
const ChosenCountry: React.FC<ChosenCountryProps> = ({ country, onChange, className = '' }) => (
  <p className={`inline-flex items-center gap-2 text-sm text-ink-muted ${className}`}>
    <span aria-hidden="true">{COUNTRIES[country].flag}</span>
    <span>{COUNTRIES[country].label}</span>
    <button type="button" className="link link-primary" onClick={onChange}>
      Change country
    </button>
  </p>
);

export default ChosenCountry;
